var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pageData)?_c('div',{key:_vm.$route.meta.id},[_c('builder-loop',{attrs:{"builder":_vm.pageData.builder}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }